import logoTFI from "../images/logoTFI.PNG";
import logoBINUS from "../images/logo_binus.png";

const FooterWeb = () => {
  return (
    <section className="footer">
      <div className="container">
        <div className="footer-col">
          <h4>relasi apps</h4>
          <ul>
            <li>
              <div className="nomer-container">
                <h5>085192456785</h5>
              </div>
            </li>
            <li>
              <div className="nomer-container">
                <h5>tfi.kemanggisan@binus.edu</h5>
              </div>
            </li>
            <li>
              <div className="nomer-container">
                <h5>
                  Jl. Kebon Jeruk Raya No. 27, Kec. Kebon Jeruk, Kota Jakarta
                  Barat 11530
                </h5>
              </div>
            </li>
          </ul>
        </div>

        <div className="footer-col-logo">
          <div className="logo-tfi">
            <a href="http://www.teachforindonesia.org/%22%3E">
              <img className="logo-TFI" src={logoTFI} alt="Logo TFI"></img>
            </a>
          </div>

          <div className="logo-binus">
            <a href="https://binus.ac.id/%22%3E">
              <img
                className="logo-Binus"
                src={logoBINUS}
                alt="Logo Binus"
              ></img>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterWeb;
